import {Avatar, Box, IconButton} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import {styled} from "@mui/material/styles";

const StyledBox = styled(Box)(({ theme }) => ({
    position: 'relative',
    display: 'inline-block',
    '& .MuiAvatar-root': {
        width: 96,
        height: 96,
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[1],
        transition: theme.transitions.create(['transform', 'box-shadow'], {
            duration: theme.transitions.duration.standard,
        }),
        '&:hover': {
            boxShadow: theme.shadows[3],
        },
    },
    '& .MuiIconButton-root': {
        position: 'absolute',
        top: 4,
        right: 4,
        padding: 4,
        zIndex: 10,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        border: `1px solid ${theme.palette.divider}`,
        backdropFilter: 'blur(4px)',
        transition: theme.transitions.create(['background-color', 'box-shadow'], {
            duration: theme.transitions.duration.shortest,
        }),
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            color: '#fff',
            boxShadow: theme.shadows[4],
        },
    }
}));

export const AvatarBox = ({avatar, name, onClick}) => {

    return (
        <StyledBox>
            <Avatar
                src={avatar || '/images/item.jpg'}
                alt={name}
                variant="rounded"
            />
            <IconButton onClick={onClick}>
                <EditIcon fontSize="small" />
            </IconButton>
        </StyledBox>
    );
}
